import React from 'react';
import PropTypes from 'prop-types';


export default class FilterItemDropdown extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const { filterId, filterSelectionChanged} = this.props;
        const value = event.target.value;
        filterSelectionChanged(filterId, value, value);
    }

    render() {
        const { title, options } = this.props;

        if(options.length <= 1) return null;
        
        return (
            <div className="filter-container">
                <div className="filter-section">
                    <h3>{title}</h3>
                    <div>
                        <select id="budgets-dropdown" className="m-dropdown-list" onChange={this.handleChange}>
                        <option value="all" key='all'>All</option>
                            {options.map((budget) => (
                                <option key={budget.id} value={budget.id}>
                                {budget.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    }

}

FilterItemDropdown.propTypes = {
    filterId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    filterSelectionChanged: PropTypes.func
};